import { SOCIAL_LINKS } from './externalLinks';
import PAGE_SEO from './seo-pages.json';

export const SITE_URL = 'https://humpro.in';
export const SITE_NAME = 'HumPro Ecosystem';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.jpg`;
export const CONTACT_EMAIL = 'humproecosystem@gmail.com';

const HOME_SEO = PAGE_SEO['/'];

export function getSeoForPath(pathname) {
  return PAGE_SEO[pathname] || HOME_SEO;
}

export function getCanonicalUrl(pathname) {
  if (pathname === '/') {
    return `${SITE_URL}/`;
  }
  return `${SITE_URL}${pathname}`;
}

function buildBreadcrumbJsonLd(pathname, breadcrumbLabel) {
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: `${SITE_URL}/`,
    },
  ];

  if (pathname !== '/') {
    items.push({
      '@type': 'ListItem',
      position: 2,
      name: breadcrumbLabel,
      item: getCanonicalUrl(pathname),
    });
  }

  return {
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
}

function buildWebPageJsonLd(pathname, seo) {
  return {
    '@type': 'WebPage',
    name: seo.title,
    description: seo.description,
    url: getCanonicalUrl(pathname),
    isPartOf: {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: `${SITE_URL}/`,
    },
    inLanguage: ['en', 'hi'],
  };
}

export function buildStructuredData(pathname) {
  const seo = getSeoForPath(pathname);
  const graph = [
    {
      '@type': 'Organization',
      name: SITE_NAME,
      url: `${SITE_URL}/`,
      logo: DEFAULT_OG_IMAGE,
      email: CONTACT_EMAIL,
      sameAs: [
        SOCIAL_LINKS.linkedin,
        SOCIAL_LINKS.youtube,
        SOCIAL_LINKS.instagram,
        SOCIAL_LINKS.facebook,
      ],
    },
    {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: `${SITE_URL}/`,
      inLanguage: ['en', 'hi'],
      publisher: {
        '@type': 'Organization',
        name: SITE_NAME,
      },
    },
    buildWebPageJsonLd(pathname, seo),
    buildBreadcrumbJsonLd(pathname, seo.breadcrumb),
  ];

  if (pathname === '/') {
    graph.push({
      '@type': 'ItemList',
      name: 'HumPro site pages',
      itemListElement: [
        { '@type': 'SiteNavigationElement', position: 1, name: 'About', url: `${SITE_URL}/about` },
        { '@type': 'SiteNavigationElement', position: 2, name: 'Courses', url: `${SITE_URL}/courses` },
        { '@type': 'SiteNavigationElement', position: 3, name: 'Consultancy', url: `${SITE_URL}/consultancy` },
        { '@type': 'SiteNavigationElement', position: 4, name: 'Careers', url: `${SITE_URL}/careers` },
        { '@type': 'SiteNavigationElement', position: 5, name: 'Contact', url: `${SITE_URL}/contact` },
        { '@type': 'SiteNavigationElement', position: 6, name: 'Privacy', url: `${SITE_URL}/privacy` },
        { '@type': 'SiteNavigationElement', position: 7, name: 'Terms', url: `${SITE_URL}/terms` },
      ],
    });
  }

  return {
    '@context': 'https://schema.org',
    '@graph': graph,
  };
}

export const SITEMAP_PATHS = Object.keys(PAGE_SEO);
